import { Box, Collapse, FormField, RadioGroup, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { RuleFooter, RuleHelperLayout } from '@wix/rules-panel-ui';
import { useSetAtom } from 'jotai';
import React, { useCallback, useMemo, useState } from 'react';
import { unsavedChangedHandlersAtom } from '../../../../atoms/session-atoms';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { useResetUnsavedChangesHandlers } from '../../../../hooks/use-reset-unsaved-changes-handlers';
import { getMediaAlternativesRadioOptions } from './media-alternatives-radio-options';
export const MediaAlternativesRuleContent = _ref => {
  let {
    onClickCancel,
    onClickApply,
    showLoader,
    type,
    index,
    status
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const radioGroupOptions = useMemo(() => getMediaAlternativesRadioOptions(t), [t]);
  const [selectedRadioId, setSelectedRadioId] = useState(type);
  const setUnsavedChangedHandlers = useSetAtom(unsavedChangedHandlersAtom);
  const {
    resetUnsavedChangesHandlers
  } = useResetUnsavedChangesHandlers();
  const handleChange = useCallback(value => {
    const newMediaType = value;
    biLogger.taskElementCtaClick({
      ctaName: newMediaType,
      index,
      status
    });
    setSelectedRadioId(undefined);
    setTimeout(() => setSelectedRadioId(newMediaType), 300);
    if (newMediaType !== type) {
      setUnsavedChangedHandlers({
        apply: async () => {
          onClickApply(newMediaType);
          setUnsavedChangedHandlers({
            apply: async () => {},
            exists: false
          });
        },
        exists: true
      });
    } else {
      resetUnsavedChangesHandlers();
    }
  }, [biLogger, index, onClickApply, resetUnsavedChangesHandlers, setUnsavedChangedHandlers, status, type]);
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    marginTop: "SP1"
  }, /*#__PURE__*/React.createElement(FormField, {
    label: t('accessibility-wizard.rules-list.media-alternatives.radio.label'),
    maxLines: 3,
    ellipsis: true
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    disabled: showLoader,
    size: "small",
    spacing: "-6px",
    value: selectedRadioId,
    onChange: handleChange
  }, radioGroupOptions.map((_ref2, radioIndex) => {
    let {
      id,
      requirements,
      label,
      secondaryLabel
    } = _ref2;
    return /*#__PURE__*/React.createElement(RadioGroup.Radio, {
      checked: selectedRadioId === id,
      content: /*#__PURE__*/React.createElement(Collapse, {
        open: selectedRadioId === id
      }, /*#__PURE__*/React.createElement(Box, {
        style: radioIndex !== radioGroupOptions.length - 1 ? {
          marginBlockEnd: '6px'
        } : undefined
      }, /*#__PURE__*/React.createElement(RuleHelperLayout, null, /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        gap: "SP1"
      }, /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold",
        secondary: true
      }, t('accessibility-wizard.rules-list.media-alternatives.radio.requirements')), /*#__PURE__*/React.createElement(Text, {
        listStyle: "circle",
        size: "tiny",
        secondary: true
      }, requirements), /*#__PURE__*/React.createElement(RuleFooter, {
        dismissButtonProps: {
          label: t('accessibility-wizard.rules-list.media-alternatives.element.footer-button.cancel'),
          onClick: () => {
            onClickCancel();
            resetUnsavedChangesHandlers();
          }
        },
        submitButtonProps: {
          disabled: type === id,
          label: t('accessibility-wizard.rules-list.media-alternatives.element.footer-button.confirm'),
          onClick: () => {
            var _radioGroupOptions$fi;
            onClickApply(((_radioGroupOptions$fi = radioGroupOptions.find(_ref3 => {
              let {
                id: optionId
              } = _ref3;
              return optionId === selectedRadioId;
            })) == null ? void 0 : _radioGroupOptions$fi.option) ?? type);
            resetUnsavedChangesHandlers();
          },
          showLoader
        }
      }))))),
      key: id,
      value: id
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      gap: "4px"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "normal"
    }, label), secondaryLabel && /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      weight: "thin"
    }, secondaryLabel)));
  }))));
};
//# sourceMappingURL=media-alternatives-rule-content.js.map